import React from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import TDPTableSelectRedux from '../TDP/TDPTableSelectRedux';
import TurmaDisciplinaProfessorProfileRedux from '../TDP/TurmaDisciplinaProfessorProfileRedux';
import { useSelector } from 'react-redux';
import AtividadeForm from './AtividadeForm';
import AtividadeTable from './AtividadeTable';

const useStyles = makeStyles({
    paper: {
        padding: '20px',
    },
    title: {
        marginBottom: '20px',
    },
});

export default function AtividadeContainer() {
    const classes = useStyles();
    const tdp = useSelector(state => state.tdp);
    const atividade = useSelector(state => state.atividade);

    return (
        <Container className={classes.paper} component={Paper}>
            <Typography className={classes.title} variant="h6">
                Atividades
            </Typography>

            {tdp ?
                <>
                    <TurmaDisciplinaProfessorProfileRedux />
                    {atividade ? <AtividadeForm /> : <AtividadeTable />}

                </> :
                <TDPTableSelectRedux />
            }
        </Container>
    );
}